import moment from "moment";
export const convertTimezone = (timeStamp) =>{
    return moment(timeStamp).fromNow()
}
